import { createContext, useContext, type ReactNode, type ComponentType } from "react";
import QuoteFormPopup from "@/components/QuoteFormPopup";

/**
 * A CTA wrapper receives a trigger element as children and is responsible for
 * opening whatever popup flow that variant uses (plain form on /lp, two-step
 * calculator on /lander-calc).
 *
 * The optional `location` prop lets sections tag which CTA fired (for GTM).
 */
export type CtaWrapperProps = {
  children: ReactNode;
  /** Where this CTA lives on the page — used for tracking. */
  location?: string;
};

export type CalcCtaValue = {
  CtaWrapper: ComponentType<CtaWrapperProps>;
  ctaLabel: string;
};

const DefaultCtaWrapper = ({ children }: CtaWrapperProps) => (
  <QuoteFormPopup>{children}</QuoteFormPopup>
);

const defaultValue: CalcCtaValue = {
  CtaWrapper: DefaultCtaWrapper,
  ctaLabel: "Get My Free Shortlist",
};

const CalcCtaContext = createContext<CalcCtaValue>(defaultValue);

export const CalcCtaProvider = ({
  value,
  children,
}: {
  value: CalcCtaValue;
  children: ReactNode;
}) => <CalcCtaContext.Provider value={value}>{children}</CalcCtaContext.Provider>;

export const useCalcCta = () => useContext(CalcCtaContext);
